export default __webpack_public_path__ + "static/media/deepak_3.b7301cf8.jpeg";